/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel compatibility`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_tag = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excel 兼容性`)
};

/**
* | output |
* | --- |
* | "Excel compatibility" |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_tag = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_TagInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_tag(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_tag(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_tag as "gc.search_guides.gridcraft_excel_compatibility.tag" }